module.exports = __webpack_public_path__ + "img/uranoya.e24b3f80.jpg";